import { Component } from "preact";
import { Card } from "react-bootstrap";

export default function Heading({ children, title, className, childrenClassName, animated = true, borderBottom = true }) {

    return (
        <>
            <Card className={`position-relative bg-white p-2  rounded ${className ?? ''} ${animated ? 'animate__animated animate__zoomInUp animate__faster' : ''}`} style={{ zIndex: 1 }}>
                <Card.Header className="bg-white border-0">
                    {title ? <h2 className={`${borderBottom ? 'border-bottom' : ''} pb-2 mb-3`}>{title}</h2> : null}

                    <div className={`d-block ${childrenClassName ?? ''}`}>
                        {children}
                    </div>
                </Card.Header>
            </Card>
        </>
    );

}
